// ** OnList
const initialState = {
  allPeople: {
    is_open: false,
    data: {}
  },
  points: null
}

const xatlovFromMap = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ALL_PEOPLE":
      return { ...state, allPeople: { is_open: action.val, data: action.data } }
    case "SET_POINTS_ALL_PEOPLE":
      return { ...state, points: action.val }
    default:
      return state
  }
}

export default xatlovFromMap
